import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Alert } from "react-bootstrap";
import Translator, { __ } from "services/Translator";
import SignupFormPanel from "components/SignupFormPanel";
import AuthInputWrap from "components/AuthInputWrap";
import ModalCloseButton from "components/ModalCloseButton";
import SocialLogin from "components/SocialLogin";
import { AuthMobileWelcomeOffer } from "components/AuthWelcomePromo";

export default function ClassicAuthModalBody({
  activeTab,
  alertMsg,
  closeLoginModal,
  props,
  loginForm,
  errors,
  updateInput,
  checkInput,
  login,
  openRecoverPssModal,
  handleSignupSuccess,
  setSpinner,
  setActiveTab,
  externalBonusOffer,
  onSignupBonusChange,
}) {
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const handleLogin = async (ev) => {
    ev.preventDefault();
    if (isLoggingIn) return;
    setIsLoggingIn(true);
    try {
      await login(ev);
    } finally {
      setIsLoggingIn(false);
    }
  };

  return (
    <>
      <ModalCloseButton onClick={closeLoginModal} className="modal_close_reg" />

      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="login_reg_area">
              <Alert show={alertMsg.showAlert} variant={alertMsg.variant}>
                {alertMsg.message}
              </Alert>
              <div className="loginRegLogoWrap">
                <img
                  alt="Play365"
                  className="loginRegLogo"
                  src={require("assets/play365/images/logos/logo.webp")}
                />
              </div>

              {activeTab === "login" ? (
                <div className="modal_headline">{__("Log In")}</div>
              ) : (
                <>
                  <div className="modal_headline">{__("Join Now")}</div>
                  {props.isMobileDevice ? <AuthMobileWelcomeOffer /> : null}
                </>
              )}

              {activeTab === "login" && (
                <>
                  <div className="form_area">
                    <form autoComplete="off" onSubmit={handleLogin}>
                      <div className="input_item">
                        <AuthInputWrap icon="far fa-user">
                          <input
                            type="text"
                            name="email"
                            value={loginForm.email}
                            onChange={updateInput}
                            onBlur={checkInput}
                            autoComplete="off"
                            className={" name_value " + (errors.email ? "error" : "")}
                            placeholder={__("Username or Email")}
                          />
                        </AuthInputWrap>
                        <div className="errorMsg">{errors.email}</div>
                      </div>
                      <div className="input_item">
                        <AuthInputWrap icon="far fa-lock">
                          <input
                            type="password"
                            name="password"
                            className={" name_value " + (errors.password ? "error" : "")}
                            value={loginForm.password}
                            autoComplete="off"
                            onChange={updateInput}
                            onBlur={checkInput}
                            placeholder={__("Enter Password")}
                          />
                        </AuthInputWrap>
                        <div className="errorMsg">{errors.password}</div>
                        <button type="button" onClick={openRecoverPssModal} className="forgot_pass_link">
                          {__("Forgot?")}
                        </button>
                      </div>
                      <div className="login_button">
                        <button type="submit" className="commonBtn pOneBtn" disabled={isLoggingIn}>
                          {isLoggingIn ? __("Logging in…") : __("Log in")}
                        </button>
                      </div>
                    </form>
                  </div>

                  <div className="auth-social-classic">
                    <p className="auth-social-classic__label">{__("or log in with")}</p>
                    <SocialLogin callFrom="modal" variant="classic" googleButtonId="googleLoginClassic" showOrDivider={false} {...props} />
                  </div>
                </>
              )}

              {activeTab === "Sign up" && (
                <>
                  <SignupFormPanel
                    referralCode={props.referralCode}
                    onSuccess={handleSignupSuccess}
                    setSpinner={setSpinner}
                    closeLoginModal={closeLoginModal}
                    onBonusOfferChange={onSignupBonusChange}
                  />
                  <div className="auth-social-classic">
                    <p className="auth-social-classic__label">{__("or register with")}</p>
                    <SocialLogin
                      callFrom="modal"
                      variant="classic"
                      googleButtonId="googleLoginClassicSignup"
                      bonusOffer={externalBonusOffer}
                      referralCode={props.referralCode}
                      showOrDivider={false}
                      {...props}
                    />
                  </div>
                </>
              )}

              {activeTab === "Sign up" && (
                <div className="routing_text">
                  {__("Already have an account?")}{" "}
                  <button
                    type="button"
                    className="routing_text__link"
                    onClick={() => setActiveTab("login")}
                  >
                    {__("Log in")}
                  </button>
                </div>
              )}
              {activeTab === "login" && (
                <div className="routing_text">
                  {__("Don't have an account?")}{" "}
                  <button
                    type="button"
                    className="routing_text__link"
                    onClick={() => setActiveTab("Sign up")}
                  >
                    {__("Sign up")}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
